export default __webpack_public_path__ + "static/reset-pass-img-cd3bd79b856a63d488225847bdd08d78.jpg";